import { render, staticRenderFns } from "./interSentList.vue?vue&type=template&id=680394a6&scoped=true&"
import script from "./interSentList.vue?vue&type=script&lang=js&"
export * from "./interSentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680394a6",
  null
  
)

export default component.exports